import { render, staticRenderFns } from "./TeamBoardDetails.vue?vue&type=template&id=b7b1f834&"
import script from "./TeamBoardDetails.vue?vue&type=script&lang=ts&"
export * from "./TeamBoardDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports